import { action,observable,computed,toJS } from 'mobx'
import T from 'i18n-react'
import COLLECTION_IMAGE_PLACEHOLDER from '../collection.png'
import route from './fetchconfig.json'



export default class Store {
 constructor () {
   this.clearFilter()

   this.settings = new Settings({})
   this.impressum = new Impressum({})
   this.wpSettings = {}
   this.cart = new Cart()
   this.items = []
   this.beispieltypen = []
   this.offset = 0
   this.setCollectionToInspect([])
 }

 ONE_LESSON = 45

 @observable lehrplan
 @observable beispieltypen
 @observable settings
 @observable wpSettings
 @observable items
 @observable cart

 @observable zyklus1
 @observable zyklus2
 @observable zyklus3
 @observable typeFilter
 @observable competenceStepFilter
 @observable offset
 @observable query

 @observable itemToInspect
 @observable collectionToInspect

 @observable isAuthorized = false
 @observable loadingCatalogItems = false
 @observable initialFetchLoaded = false
 @observable moreCatalogContentToLoad = true


 @observable exampleForm = {
   asUpdate:false,
   asSuggestion:true,
   asDeleteRestore:false,
   currentExample:null
 }

 @observable collectionForm = {
   asUpdate:false,
   asSuggestion:true,
   asDeleteRestore:false,
   currentCollection:null
 }

 CATALOG_ITEM_TYPE_EXAMPLE = 1
 CATALOG_ITEM_TYPE_COLLECTION = 2
 CATALOG_MAX_ITEMS_TO_SCROLL_BEFORE_CLEARING = 100
 ITEM_OFFSET_INCREMENT = 10


 // hack
 @observable deletePointer = null

 @action.bound setCurrentCollection (collection) {
   this.collectionForm.currentCollection = collection
 }

 @action.bound setCollectionFormAsSuggestion () {
   this.collectionForm.asSuggestion = true
   this.collectionForm.asUpdate = false
   this.collectionForm.asDeleteRestore = false
   this.collectionForm.currentExample = null
 }

 @action.bound setCollectionFormAsUpdate () {
   this.collectionForm.asSuggestion = false
   this.collectionForm.asDeleteRestore = false
   this.collectionForm.asUpdate = true
 }

 @action.bound setCurrentExample (example) {
   this.exampleForm.currentExample = example
 }

 @action.bound setExampleFormAsSuggestion () {
   this.exampleForm.asSuggestion = true
   this.exampleForm.asUpdate = false
   this.exampleForm.asDeleteRestore = false
   this.exampleForm.currentExample = null
 }

 @action.bound setExampleFormAsUpdate () {
   this.exampleForm.asSuggestion = false
   this.exampleForm.asDeleteRestore = false
   this.exampleForm.asUpdate = true
 }

 @action.bound sudo (token) {
   fetch(route.endpoint + '/api/token/verify?token='+token,{
     method:'GET',
     credentials:'include'
   })
   .then((res) => res.json())
   .then((data) => {
     this.isAuthorized = data.success
   })
   .catch((error) => {
     console.error(error);
   })

 }

 @action.bound sudoDelete (item,cb) {
   if (item && item.id && item.id !== "") {
    if (item.isExample) {
     this.sudoDeleteItem(item.id, (succeeded) => {
       if (succeeded) {
         this.removeItemFromCatalog(item,this.CATALOG_ITEM_TYPE_EXAMPLE)
         if (cb) cb(succeeded)
       }
     })
    }
    else if (item.isCollection) {
      this.sudoDeleteCollection(item.id, (succeeded) => {
        if (succeeded) {
          this.removeItemFromCatalog(item,this.CATALOG_ITEM_TYPE_COLLECTION)
          if (cb) cb(succeeded)
        }
      })
    }
   }
 }

 @action.bound removeItemFromCatalog (item,type) {
   this.items = this.items.filter( (currItem) => {
     if (currItem.id !== item.id) {
       if (currItem.isExample) {
         return type !== this.CATALOG_ITEM_TYPE_COLLECTION
       }
       else if (currItem.isCollection) {
         return type !== this.CATALOG_ITEM_TYPE_EXAMPLE
       }
     }
   })
 }

 @computed get collectionName () {
   return this.beispieltypen && this.beispieltypen.length > 0 ? this.beispieltypen[0].name : ''
 }

 @action.bound setQuery (query) {
   this.query = query
 }

 @action.bound toggleTypeFilter (id) {
   if (!this.isActiveTypeFilter(id)) {
    this.addTypeFilter(id)
   } else {
    this.removeTypeFilter(id)
  }
  this.resetCatalog()
 }

 isActiveTypeFilter (id) {
   for (let i = 0; i < this.typeFilter.length; i++) {
     if (this.typeFilter[i] === id) {
       return true
     }
   }
   return false
 }

 @action addTypeFilter (id) {
   this.typeFilter.push(id)
 }

 @action removeTypeFilter (id) {
   this.typeFilter = this.typeFilter.filter( (item) => {
     if (item !== id) {
       return item
     }
   })
 }

 @action.bound toggleCycle (cycle) {
   const doNotTriggerSearch = true
   this.resetCatalog(doNotTriggerSearch)

   if (cycle === 1) this.zyklus1 = !this.zyklus1
   if (cycle === 2) this.zyklus2 = !this.zyklus2
   if (cycle === 3) this.zyklus3 = !this.zyklus3

   // if all cycles are deselected - select them all
   if (!this.zyklus1 && !this.zyklus2 && !this.zyklus3) {
     this.zyklus1 = !this.zyklus1
     this.zyklus2 = !this.zyklus2
     this.zyklus3 = !this.zyklus3
   }

   this.search()
 }

 getChipData () {
  let temp = []
  let arr = this.competenceStepFilter
  if (!arr|| arr.length === 0) return temp

  for (let i = 0; i < this.lehrplan.length; i++) {
    let kompetenz = this.lehrplan[i]
    for (let j = 0; j < kompetenz.kompetenzstufen.length; j++) {
      let kompetenzStufe = kompetenz.kompetenzstufen[j]
      for (let k = 0; k < arr.length; k++) {
        let filter = arr[k]
        if (kompetenzStufe.id === filter) {
          temp.push(kompetenzStufe)
        }
      }
    }
  }

  return temp
 }

 @action.bound toggleCompetenceStepFilter (id) {
   if (!this.isActiveCompetenceStepFilter(id)) {
    this.addCompetenceStepFilter(id)
   } else {
    this.removeCompetenceStepFilter(id)
  }
 }

 isActiveCompetenceStepFilter (id) {
   for (let i = 0; i < this.competenceStepFilter.length; i++) {
     if (this.competenceStepFilter[i] === id) {
       return true
     }
   }
   return false
 }

 @action addCompetenceStepFilter (id) {
   this.competenceStepFilter.push(id)
 }

 @action removeCompetenceStepFilter (id) {
   this.competenceStepFilter = this.competenceStepFilter.filter( (item) => {
    if (item !== id) {
      return item
    }
   })
   this.resetCatalog()
 }

 @computed get hasCompetenceStepFilter () {
   return this.competenceStepFilter && this.competenceStepFilter.length > 0
 }

 @action setBeispieltypen (beispieltypen) {
   this.beispieltypen = beispieltypen
 }

 @action.bound setLehrplan (lehrplan) {
   this.lehrplan = lehrplan
 }

 @action.bound setSettings (settings) {
   this.settings = new Settings(settings)
 }

 @action.bound setImpressum (impressum) {
   this.impressum = new Impressum(impressum)
 }

 @action.bound setItemToInspect (item) {
   this.itemToInspect = new ItemToInspect(item)
 }

 @action.bound setCollectionToInspect (collection) {
   this.collectionToInspect = new CollectionToInspect(collection)
 }

 @action.bound setCompetenceStepFilter (competenceSteps) {
   this.competenceStepFilter = competenceSteps
   this.resetCatalog()
 }

 @action.bound getItemImage (item) {
   if (item.isCollection) {
     if (!this.settings.collectionimage || this.settings.collectionimage === "") {
       return item.image = COLLECTION_IMAGE_PLACEHOLDER
     } else return item.image = this.settings.collectionimage
   }

   return item.image
 }

 @action addItems (items) {
  // no matches found, show empty search and its not an "load-more", reset the catalog
  if (items.length === 0 && this.offset === 0) {
    this.items = []
  }
  // matches, add to existing items
  else {
    this.items = [...this.items,...items]
  }
 }

 getApproximatedTimevalue (item) {
   const { from,to } = item
   // no from value
   if (from === 0 || !from) {
    if (!to || to === 0) {
     return ""
    }
   }


   // only one from value
   if (from && !to) {
     if (from == this.ONE_LESSON) {
       return '1 ' + T.translate('meta.lesson')
     }
     if (from == 2*this.ONE_LESSON) {
       return T.translate('meta.doubleLesson')
     }
     if (from < 2*this.ONE_LESSON && from != this.ONE_LESSON) {
       if (from < this.ONE_LESSON) {
        return from + ' ' + T.translate('meta.minutes')
       }
       return from % this.ONE_LESSON + ' ' + T.translate('meta.minutes')
     }
     if (from > 2*this.ONE_LESSON) {
       let lessons = from / this.ONE_LESSON
       if (from % this.ONE_LESSON > 0) {
         lessons++
       }
       return lessons + ' ' + T.translate('meta.lessons')
     }
   }
   // has from and to value
   else {
     if (from < 2*this.ONE_LESSON || to <= 2*this.ONE_LESSON) {
       return from + ' - ' + to + ' ' + T.translate('meta.minutes')
     }
     if (from >= 2*this.ONE_LESSON || to > 2*this.ONE_LESSON) {
       let lessonsFrom = parseInt(from / this.ONE_LESSON)
       let lessonsTo = parseInt(to / this.ONE_LESSON)

       // if difference between both values in between one lesson --> 5-5 lessons --> add one lesson to
       const minutesTo = to % this.ONE_LESSON, minutesFrom = from % this.ONE_LESSON
       if ((minutesTo + minutesFrom) < this.ONE_LESSON) {
        if (minutesFrom > minutesTo) {
          lessonsFrom--
        }
        if (minutesTo > minutesFrom) {
          lessonsTo++
        }
       }

       return lessonsFrom + ' - ' + lessonsTo + ' ' + T.translate('meta.lessons')
     }
   }

 }

 @computed get hasUserDefinedFilters () {
   return !this.zyklus1 || !this.zyklus2 || !this.zyklus3 || this.query !== "" || (this.typeFilter && this.typeFilter.length > 0) || (this.competenceStepFilter && this.competenceStepFilter.length > 0)
 }

 @action.bound clearFilter () {
   this.zyklus1 = true
   this.zyklus2 = true
   this.zyklus3 = true
   this.query = ""
   this.typeFilter = []
   this.competenceStepFilter = []
   this.resetCatalog()
 }

 @computed get hasMoreItemsToLoad () {
   return this.items.length % this.ITEM_OFFSET_INCREMENT * 2 === 0
 }

 getItemTitleAsURLString (itemId,itemTitle) {
   return route.endpoint + '/' + itemId + '/' + itemTitle.replace(/[^a-z0-9]+/gi, '-').replace(/^-*|-*$/g, '').toLowerCase()
 }

 getCollectionLink (collectionId) {
   return route.endpoint + '/collection?c=' + collectionId
 }

 getBeispielTypFirstChar (type) {
   return type.charAt(0).toUpperCase()
 }

 getBeispielTypById (id) {
   return this.beispieltypen.find(type => type.id === id)
 }

 @action incrementOffset () {
   this.offset += this.ITEM_OFFSET_INCREMENT
 }

 @action.bound resetCatalog (doNotTriggerSearch) {
   this.offset = 0
   this.items = []
   if (!doNotTriggerSearch) {
    this.search()
   }
 }

 setBrowsertabTitle (wpSettings) {
   let title = ""
   if (wpSettings.title) {
     title += wpSettings.title
     if (wpSettings.subtitle) {
       title += " - " + wpSettings.subtitle
     }
   } else title = "Made with Kool"

   document.title = title
 }

 buildSearchQuery () {
   return {
     zyklus1:this.zyklus1,
     zyklus2:this.zyklus2,
     zyklus3:this.zyklus3,
     offset:this.offset,
     query:this.query,
     types:this.typeFilter,
     competencies:this.competenceStepFilter
   }
 }

 @action.bound getAllMetadata () {
   this.reqResWithServer({
     uri:'/api/allmetadata',
     method:'GET',
     cb: (response) => {
       this.setSettings(response.settings)
       this.setBeispieltypen(response.beispieltypen)
       this.setLehrplan(response.lehrplan)
       this.wpSettings = response.wpSettings
       this.initialFetchLoaded = true

       this.setBrowsertabTitle(response.wpSettings)
     }
   })
 }

 @action.bound getSettings () {
   this.reqResWithServer({
     uri:'/api/settings',
     method:'GET',
     cb: (response) => { this.setSettings(response) }
   })
 }

 @action.bound getWPSettings () {
   this.reqResWithServer({
     uri:'/api/wpsettings',
     method:'GET',
     cb: (response) => { this.wpSettings = response.wpSettings }
   })
 }

 @action.bound getImpressum () {
   this.reqResWithServer({
     uri:'/api/impressum',
     method:'GET',
     cb: (response) => { this.setImpressum(response) }
   })
 }

 @action.bound makeScreenshot (url,cb) {
   this.reqResWithServer({
     uri:'/api/image?url='+encodeURI(url),
     method:'GET',
     cb
   })
 }

 @action.bound sudoDeleteItem (id,cb) {
   this.reqResWithServer({
     uri:'/api/item/delete?id='+id,
     method:'GET',
     cb: cb
   })
 }

 @action.bound sudoDeletePermItem (id,cb) {
   this.reqResWithServer({
     uri:'/api/item/delete/perm?id='+id,
     method:'GET',
     cb: cb
   })
 }

 @action.bound sudoRestoreItem (id,cb) {
   this.reqResWithServer({
     uri:'/api/item/restore?id='+id,
     method:'GET',
     cb: cb
   })
 }

 @action.bound generatePDFForCollection (payload,variant,cb) {
   fetch('/api/collection/pdf', {
     headers: {
       'Accept': 'application/pdf',
       'Content-Type': 'application/json',
     },
    method:'POST',
    responseType: 'blob',
    body:JSON.stringify({payload:payload,variant:variant})
   })
   .then(response => response.blob())
   .then(cb)
 }

 @action.bound sudoDeleteCollection (id,cb) {
   this.reqResWithServer({
     uri:'/api/collection/delete?id='+id,
     method:'GET',
     cb: cb
   })
 }

 @action.bound sudoDeletePermCollection (id,cb) {
   this.reqResWithServer({
     uri:'/api/collection/delete/perm?id='+id,
     method:'GET',
     cb: cb
   })
 }

 @action.bound sudoRestoreCollection (id,cb) {
   this.reqResWithServer({
     uri:'/api/collection/restore?id='+id,
     method:'GET',
     cb: cb
   })
 }

 @action.bound getItemDetails (itemId,cb) {
   this.reqResWithServer({
     uri:'/api/item?id='+itemId,
     method:'GET',
     cb: (response) => {
       this.setItemToInspect(response)
       if (cb) cb(response)
     }
   })
 }

 @action.bound search () {
   this.loadingCatalogItems = true
   this.reqResWithServer({
     uri:'/api/search',
     method:'POST',
     body:this.buildSearchQuery(),
     cb: (data) => {
      this.addItems(data)
      this.loadingCatalogItems = false
      if (data && data.length > 0) {
       this.moreCatalogContentToLoad = true
      } else this.moreCatalogContentToLoad = false
     }
   })
 }

 @action.bound loadMoreResults () {
   this.incrementOffset()
   this.search()
 }

 @action.bound getItems (itemIDs,cb) {
   this.reqResWithServer({
     uri:'/api/collection?ids=' + itemIDs,
     method:'GET',
     cb
   })
 }

 @action.bound getCollectionDetails (itemIDs,title,description) {
   this.reqResWithServer({
     uri:'/api/collection?ids=' + itemIDs,
     method:'GET',
     cb: (response) => {
      response.title = title
      response.description = description

      this.setCollectionToInspect(response)
     }
   })
 }

 @action.bound getCollectionDetailsFromPublishedCollection (collectionId) {
   this.reqResWithServer({
     uri:'/api/collection?c=' + collectionId,
     method:'GET',
     cb: (response) => { this.setCollectionToInspect(response) }
   })
 }

 @action.bound sendSuggestion (payload,cb) {
   this.reqResWithServer({
     uri:'/api/item/suggestion',
     method:'POST',
     body:payload,
     cb: cb
   })
 }

 @action.bound sendSuggestionCollection (payload,cb) {
   this.reqResWithServer({
     uri:'/api/collection/suggestion',
     method:'POST',
     body:payload,
     cb: cb
   })
 }

 @action.bound updateCollection (payload,cb) {
   this.reqResWithServer({
     uri:'/api/collection/update',
     method:'POST',
     body:payload,
     cb: cb
   })
 }

 @action.bound acceptCollection (payload,cb) {
   this.reqResWithServer({
     uri:'/api/collection/accept',
     method:'POST',
     body:payload,
     cb: cb
   })
 }

 @action.bound declineCollection (id,cb) {
   this.reqResWithServer({
     uri:'/api/collection/decline?id='+id,
     method:'GET',
     cb: cb
   })
 }

 @action.bound updateExample (payload,cb) {
   this.reqResWithServer({
     uri:'/api/item/update',
     method:'POST',
     body:payload,
     cb: cb
   })
 }

 @action.bound acceptExample (payload,cb) {
   this.reqResWithServer({
     uri:'/api/item/accept',
     method:'POST',
     body:payload,
     cb: cb
   })
 }

 @action.bound declineExample (id,cb) {
   this.reqResWithServer({
     uri:'/api/item/decline?id='+id,
     method:'GET',
     cb: cb
   })
 }

 reqResWithServer (options) {
  const {uri,method,cb,body} = options

  if (method === 'POST') {
    fetch(route.endpoint + uri, {
       method: method,
       headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json',
       },
       body: (body ? JSON.stringify(body) : {})
     })
     .then((res) => res.json())
     .then((data) => {
       cb(data)
     })
     .catch((error) => {
       console.error(error);
     })
  }
  else if (method === 'GET') {
    fetch(uri, {
       method: method,
       headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json',
       },
     })
     .then((res) => res.json())
     .then((data) => {
       cb(data)
     })
     .catch((error) => {
       console.error(error);
     })
  }


 }

 forEach (array,doEachStep,callbackDone) {
  let done = 0, results = []
  const waitUntil = array.length,
  temp = (item) => {
   doEachStep(item, (res) => {
    results.push(res)
    done++;
    if (done == waitUntil) callbackDone(results);
   })
  }

  for (let i = 0; i < array.length; i++) {
   temp(array[i])
  }
 }

 getParameterByName (name, url) {
   if (!url) url = window.location.href
   name = name.replace(/[\[\]]/g, "\\$&")
   const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)")
   let results = regex.exec(url)
   if (!results) return null
   if (!results[2]) return ''
   return decodeURIComponent(results[2].replace(/\+/g, " "))
  }

}

class Impressum {
 @observable phone
 @observable mail
 @observable company
 @observable street
 @observable zip
 @observable location
 @observable country
 @observable persons

 constructor (impressum) {
  const { phone,mail,company,street,zip,location,country,persons } = impressum
  this.phone = phone ? phone : ""
  this.mail = mail ? mail : ""
  this.company = company ? company : ""
  this.street = street ? street : ""
  this.zip = zip ? zip : ""
  this.location = location ? location : ""
  this.country = country ? country : ""
  this.persons = persons ? persons : ""
 }

}

class Settings {
 title
 subtitle
 primaryColor
 accentColor
 menuLinkOne
 menuLinkTwo
 collectionimage

 @observable currentMenuLink = {url:"",description:""}

 constructor (settings) {
  const {title,subtitle,primaryColor,accentColor,menuLinkOne,menuLinkTwo,collectionimage} = settings
  this.title = title ? title : ""
  this.subtitle = subtitle ? subtitle : ""
  this.primaryColor = primaryColor ? primaryColor : ""
  this.accentColor = accentColor ? accentColor : ""
  this.menuLinkOne = menuLinkOne ? menuLinkOne : {url:"",description:""}
  this.menuLinkTwo = menuLinkTwo ? menuLinkTwo : {url:"",description:""}
  this.collectionimage = collectionimage ? collectionimage : ""
 }

 @action.bound setCurrentMenuLink (menuLink) {
   this.currentMenuLink = menuLink
 }

 @computed get hasMenuLinkOne () {
   return this.menuLinkOne && this.menuLinkOne.url && this.menuLinkOne.url !== "" && this.menuLinkOne.description && this.menuLinkOne.description !== ""
 }

 @computed get hasMenuLinkTwo () {
   return this.menuLinkTwo && this.menuLinkTwo.url && this.menuLinkTwo.url !== "" && this.menuLinkTwo.description && this.menuLinkTwo.description !== ""
 }

}

class CollectionToInspect {
  @observable items
  @observable title
  @observable description
  @observable createPdfFromCollectionLoading = false

  constructor (collection) {
    this.items = collection.items ? collection.items : []
    this.title = collection.title ? collection.title : ""
    this.description = collection.description ? collection.description : ""
  }

  @action setCreatePdfFromCollectionLoading = (value) => {
    this.createPdfFromCollectionLoading = value
  }

  getCollectionGroupedByItemType () {
   let items = this.sortItemsByName()
   let lastItemType = -1, grouped = [], temp = []

   for (let i = 0; i < items.length; i++) {
     const item = items[i]
     if (item.typeId !== lastItemType) {
       temp = []
       grouped.push(temp)
     }
     temp.push(item)
     lastItemType = item.typeId
   }

   grouped = grouped.filter(items => this.sortItemsByName(items))
   return grouped
 }

 sortCollectionByType (items) {
   return items.sort( (a,b) => { return a.typeId - b.typeId })
 }

 sortItemsByItemType () {
   return this.items.sort( (a,b) => { return a.typeId - b.typeId })
 }
 sortItemsByName () {
   return this.items.sort(function(a, b){
    if(a.title < b.title) { return -1; }
    if(a.title > b.title) { return 1; }
    return 0;
  })
 }

}

class ItemToInspect {
  id
  title
  description
  image
  link
  kompetenzstufen
  to
  from
  type
  typeId
  zyklus1
  zyklus2
  zyklus3

  constructor (item) {
    const {id,title,description,image,link,kompetenzstufen,to,from,type,typeId,zyklus1,zyklus2,zyklus3} = item
    this.id = id
    this.title = title
    this.description = description
    this.image = image
    this.link = link
    this.kompetenzstufen = kompetenzstufen
    this.to = to
    this.from = from
    this.type = type
    this.typeId = typeId
    this.zyklus1 = zyklus1
    this.zyklus2 = zyklus2
    this.zyklus3 = zyklus3
  }

}

class Cart {
 ONE_LESSON = 45

 @observable items = []
 @observable mailToSendCart = ""
 @observable title = ""
 @observable description = ""

 @action.bound setMailToSendCart (mail) {
   this.mailToSendCart = mail
 }
 @action.bound setTitle (title) {
   this.title = title
 }
 @action.bound setDescription (description) {
   this.description = description
 }

 sendMailWithCartInfos (cb) {
  fetch(route.endpoint + '/api/cart/mail?m='+this.mailToSendCart+'&s='+this.sharelink, {
   method: 'GET'
  })
  .then((res) => res.json())
  .then((data) => {
    cb(data)
  })
  .catch((error) => {
    console.error(error);
  })
 }

 getItemIDsAsString () {
   return this.items.map(item => item.id).join(',')
 }

 @computed get lessonCount () {
  let sumFrom = 0, sumTo = 0, i = 0

  for (; i < this.items.length; i++) {
   const item = this.items[i]

   if (item.from) {
    sumFrom += parseInt(item.from)
   }
   if (item.to) {
     sumTo += parseInt(item.to)
   }
   if (!item.to) {
     sumTo += parseInt(item.from)
   }
  }

  if (sumFrom === sumTo) {
    return this.getCartLessonCountByValue(sumFrom)
  }

  if (sumFrom !== sumTo) {
    return this.getCartLessonCountByValue(sumFrom) + ' - ' + this.getCartLessonCountByValue(sumTo)
  }

 }

 getCartLessonCountByValue (value) {
   if (value && value > 0) {
     if (value < this.ONE_LESSON) {
       value = parseInt(value % this.ONE_LESSON) + ' ' + T.translate('meta.minutes')
     }
     if (value >= this.ONE_LESSON) {
       const lessons = parseInt(value / this.ONE_LESSON)
       value = lessons + ' ' + (lessons > 1 ? T.translate('meta.lessons') : T.translate('meta.lesson'))
     }
   }

   if (!value || value === 0)
    return ""

   return value
 }

 @computed get titleAndDescription () {
   let titleAndDescription = ""
   if (this.title !== "") titleAndDescription += "&title="+this.title
   if (this.description !== "") titleAndDescription += "&description="+this.description

   return titleAndDescription
 }

 @computed get sharelink () {
   return window.location.protocol + '//' + window.location.host + route.endpoint + '/collection?s=' + this.items.map(item => {return item.id}).join() + this.titleAndDescription
 }

 @computed get relativeSharelink () {
   return route.endpoint + '/collection?s=' + this.items.map(item => {return item.id}).join() + this.titleAndDescription
 }

 @computed get pdfLinkTeacher () {
   return route.endpoint + '/pdf/collection/teacher?ids='+this.items.map(item => {return item.id}).join()
 }

 @computed get pdfLinkPupils () {
   return route.endpoint + '/pdf/collection/pupils?ids='+this.items.map(item => {return item.id}).join()
 }

 @computed get pdfLinkPupilsAndTeacher () {
   return route.endpoint + '/pdf/collection/pupilsandteacher?ids='+this.items.map(item => {return item.id}).join()
 }

 @action.bound clearAll () {
   this.items = []
   this.title = ""
   this.description = ""
 }

 @action.bound toggleItem (item) {
  if (!this.hasItem(item.id)) {
   this.addItem(item)
  } else this.removeItem(item)
 }

 @action.bound removeItem (removeMe) {
   this.items = this.items.filter(item => item.id !== removeMe.id)
 }

 @action addItem (item) {
   this.items.push(item)
 }

 @action.bound toggleCollection (items) {
   if (this.hasTheseItems(items)) {
    // already all items included in cart from the collection
    items.map(item => {this.removeItem(item)})
   } else {
     // not all items included, add the missing ones
    items.map(item => {
     const checkId = item.id ? item.id : item
     if (!this.hasItem(checkId)) {this.addItem(item)}
    })
   }
 }

 @computed get hasItems () {
   return this.items.length > 0
 }

 @computed get maxTypeId () {
   let max = 0
   this.items.map( item => item.typeId > max ? max = item.typeId : max )
   return max
 }

 @computed get minTypeId () {
   let min = this.maxTypeId
   this.items.map( item => item.typeId < min ? min = item.typeId : min )
   return min
 }

 hasTheseItems (items) {
   let temp = []

   for (let i = 0; i < items.length; i++) {
     for (let j = 0; j < this.items.length; j++) {
      const checkId = items[i].id ? items[i].id : items[i]
      if (checkId === this.items[j].id) {
        temp.push(true)
      }
     }
   }

   return temp.length === items.length
 }

 hasItem (id) {
   for (let i = 0; i < this.items.length; i++) {
     if (this.items[i].id === id) {
       return true
     }
   }
   return false
 }

 sortItemsByItemType () {
   return this.items.sort( (a,b) => { return a.typeId - b.typeId })
 }

 getItemsGroupedByItemType () {
   const items = this.sortItemsByItemType()
   let lastItemType = -1, grouped = [], temp = []

   items.map( item => {
     if (item.typeId !== lastItemType) {
       temp = []
       grouped.push(temp)
     }
     temp.push(item)
     lastItemType = item.typeId
   })

   return grouped
 }

}



// WEBPACK FOOTER //
// ./src/stores/store.js